import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';
import React, { FC } from 'react';

import { useIsDogfoodPerfHUDEnabled } from './hooks';

const loader = () => import(/* webpackChunkName: "4-feat-perf-hud" */ './DogfoodPerfHUD');

const LazyLoadOnRenderLoadablePerfHUD = lazyLoadOnRender({ loader });

export const LoadableDogfoodPerfHUD: FC = () =>
  useIsDogfoodPerfHUDEnabled() ? <LazyLoadOnRenderLoadablePerfHUD /> : null;
